import { client } from './client'
import { ourTest, theirTest } from './translator'
import { createResponse } from '../response'

const saveTest = async (test) => {
  try {
    var payload = theirTest(test)
    let response = await client.post('/v1/routing/definition', payload)
    return response
  } catch (error) {
    throw new Error(error.response.data.message)
  }
}

const fetchTests = async () => {
  try {
    let response = await client.get('/v1/routing/definitions')
    var data = response.data.routingDefinitions.map((t) => ourTest(t))
    return createResponse(data)
  } catch (error) {
    throw new Error(error.response.data.message)
  }
}

const stopTestById = async (id) => {
  try {
    await client.put('/v1/routing/definition/' + id)
  } catch (error) {
    throw new Error(error.response.data.message)
  }
}

const fetchCountries = async () => {
  try {
    let response = await client.get('/v1/routing/countries')
    return createResponse(response.data.countries)
  } catch (error) {
    throw new Error(error.response.data.message)
  }
}

const fetchBreakoutsByCountryId = async (countryId) => {
  try {
    let response = await client.get('/v1/routing/destinations/' + countryId)
    var data = response.data.destinations
    data.forEach(function (item) {
      item.id = item.name
    })
    return createResponse(data)
  } catch (error) {
    throw new Error(error.response.data.message)
  }
}

const fetchCarriers = async () => {
  try {
    let response = await client.get('/v1/routing/carriers')
    return createResponse(response.data.carriers)
  } catch (error) {
    throw new Error(error.response.data.message)
  }
}

export {
  saveTest,
  fetchTests,
  fetchCountries,
  fetchCarriers,
  stopTestById,
  fetchBreakoutsByCountryId
}



// WEBPACK FOOTER //
// ./src/api/routing/index.js